import Vue from "vue";
import Vuex from "vuex";

// Global vuex
import AppModule from "./app";
import user from "./user";
import orderManagement from "./orderManagement";
import announcement from "sentec-vues/modules/announcement/stores";


Vue.use(Vuex);

/**
 * Main Vuex Store
 */
const store = new Vuex.Store({
  modules: {
    app: AppModule,
    user,
    orderManagement,
    announcement,
  },
});

export default store;
